import { createAction, props } from '@ngrx/store';

import { ItemsPagination } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { InstalledView, NotificationView } from 'src/app/model/device';

export const getInstalledViews = createAction('GET_INSTALLED_VIEWS', props<{
    paging?: PaginationParams;
    siteId: number;
    filter?: string;
}>());
export const getInstalledViewsSuccess = createAction('GET_INSTALLED_VIEWS_SUCCESS', props<{
    paging: ItemsPagination;
    installedViews: InstalledView[];
}>()
);
export const getInstalledViewsFailed = createAction('GET_INSTALLED_VIEWS_FAILED', props<{ errorMessage: string }>());

export const getNotificationView = createAction('GET_NOTIFICATION_VIEW', props<{
    paging?: PaginationParams;
    filter?: string;
    acls?: number[];
}>());
export const getNotificationViewSuccess = createAction('GET_NOTIFICATION_VIEW_SUCCESS', props<{
    paging: ItemsPagination;
    notificationView: NotificationView[];
}>()
);
export const getNotificationViewFailed = createAction('GET_NOTIFICATION_VIEW_FAILED', props<{ errorMessage: string }>());
